export const loginSuccessCallback = {
  callback: undefined,
  setCallback: cb => {
    if (!cb) return;
    loginSuccessCallback.callback = cb;
  }
};